import { AxiosError } from "axios";

export const isNetworkError = (error: AxiosError) => {
  return !!error.isAxiosError && !error.response;
};
